import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import useDeleteHook from "../../customHooks/useDeleteHook";
import usePaginationState from "../../customHooks/usePaginationHook";
import { useSearchParams } from "react-router-dom";

type Props = {};

const CategoryComponent = loadable(() => import("../../components/Category"));

const Category: React.FC<Props> = (props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";

  const { data: categoryData, isPending: categoryLoading } = useGetHook({
    queryKey: ["category", pageSize, offset, searchQuery],
    url: `${APIS.CATEGORY}`,
    params: {
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
    },
  });

  const { mutateAsync: deleteMutateAsync } = useDeleteHook({
    queryKey: ["category"],
  });

  const handleDelete = async (setOpenPopup: any, pk: string) => {
    const url = `${APIS.CATEGORY}${pk}/`;
    try {
      await deleteMutateAsync({ url });
      setOpenPopup(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <CategoryComponent
      categoryData={categoryData}
      handleDelete={handleDelete}
      pageSize={pageSize}
      setPageSize={setPageSize}
      offset={offset}
      setOffset={setOffset}
      categoryLoading={categoryLoading}
    />
  );
};

export default Category;
